import { Link as ChakraLink, type LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import NextLink, { type LinkProps as NextLinkProps } from 'next/link';
import { forwardRef } from 'react';

export type LinkProps = ChakraLinkProps & NextLinkProps;

export const Link = forwardRef<HTMLAnchorElement, ChakraLinkProps & NextLinkProps>(function Link(props, ref) {
  const { children, href, replace, scroll, prefetch, ...rest } = props;

  return (
    <ChakraLink {...rest} asChild>
      <NextLink ref={ref} href={href} replace={replace} scroll={scroll} prefetch={prefetch}>
        {children}
      </NextLink>
    </ChakraLink>
  );
});
